import { useEffect } from "react";
import useGameStore from "../../lib/store/GameStore";
import { BaseDialog } from "./BaseDialog";
import { gridLevelDateKey } from "../../lib/utils/gridLevels";
import { getActiveDailyConfig } from "../../lib/utils/applyTakeoverTheme";

function ScoreboardDialog() {
  const [isOpen, setIsOpen] = useGameStore((state) => [
    state.isScoreboardOpen,
    state.setIsScoreboardOpen,
  ]);
  const dailyConfig = getActiveDailyConfig(gridLevelDateKey);

  useEffect(() => {
    if (dailyConfig) {
      const storageKey = `scoreboardDialogClosed_${gridLevelDateKey}`;
      const hasClosed = sessionStorage.getItem(storageKey);
      if (!hasClosed) {
        setIsOpen(true);
      }
    }
  }, [dailyConfig]);

  function closeModal() {
    sessionStorage.setItem(
      `scoreboardDialogClosed_${gridLevelDateKey}`,
      "true",
    );
    setIsOpen(false);
  }

  if (!dailyConfig || !isOpen) {
    return null;
  }

  return (
    <BaseDialog
      isOpen={isOpen}
      closeModal={closeModal}
      modalTitle=""
      modalBody={
        <ScoreboardBody dailyConfig={dailyConfig} closeModal={closeModal} />
      }
      size="lg"
      showClose={false}
    />
  );
}

function ScoreboardBody({ dailyConfig, closeModal }) {
  return (
    <div className="text-md font-normal text-gray-700 sm:text-base">
      <div className="relative -mx-4 -mt-6 mb-4 overflow-hidden">
        <a
          href="https://open.spotify.com/episode/7mwHDCinRsRcgvpNek9Cit?si=5U-XCmgMTAqXAJFFApKCVA"
          target="_blank"
          rel="noopener"
          referrerPolicy="no-referrer-when-downgrade"
          className="block"
        >
          <img
            src={dailyConfig.backgroundImage}
            alt={dailyConfig.guestName}
            className="w-full"
          />
          <div className="absolute inset-0 dark:bg-black/30"></div>
        </a>
        <button
          type="button"
          onClick={closeModal}
          aria-label="Close"
          className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-black/60 text-white transition hover:bg-black/80"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="h-4 w-4"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
      <div className="py-2 dark:text-gray-300 md:px-2">
        <h3 className="mb-4 text-center text-xl font-semibold dark:text-gray-100 sm:text-2xl">
          Ep #{dailyConfig.episodeNumber} - {dailyConfig.guestName}
        </h3>

        <div className="mb-6 whitespace-pre-line">
          {dailyConfig.description}
        </div>

        <div className="text-center">
          <a
            href="https://open.spotify.com/episode/7mwHDCinRsRcgvpNek9Cit?si=5U-XCmgMTAqXAJFFApKCVA"
            target="_blank"
            rel="noopener"
            referrerPolicy="no-referrer-when-downgrade"
            className="mx-auto mb-3 inline-block rounded-lg bg-scoreboard-green px-5 py-2 text-center font-medium text-white transition hover:opacity-90"
          >
            Listen on Spotify →
          </a>
          <div>
            <a
              href="https://scoreboardpodcast.com/"
              target="_blank"
              rel="noopener"
              referrerPolicy="no-referrer-when-downgrade"
              className="text-sm text-gray-500 underline hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
            >
              Follow Scoreboard Pod
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScoreboardDialog;
